// backend/quotes/models.py > PricingUnit
export type PricingUnit =
  | 'unit'
  | 'kg'
  | 'g'
  | 'm'
  | 'yd'
  | 'm2'
  | 'set'
  | 'roll';

const PRICING_UNIT_SYMBOLS: Record<PricingUnit, string> = {
  unit: 'unit',
  kg: 'kg',
  g: 'g',
  m: 'm',
  yd: 'yd',
  m2: 'm²',
  set: 'set',
  roll: 'roll'
};

/** Short symbol for a pricing unit, e.g. "kg" or "m²". */
export const pricingUnitSymbol = (pricingUnit: PricingUnit): string =>
  PRICING_UNIT_SYMBOLS[pricingUnit];

/**
 * Suffix for a bulk unit price, e.g. "/kg". Empty for the default per-unit
 * pricing, so per-unit quotes read as plain prices.
 */
export const pricingUnitPriceSuffix = (
  pricingUnit: PricingUnit | null | undefined
): string =>
  pricingUnit && pricingUnit !== 'unit'
    ? `/${PRICING_UNIT_SYMBOLS[pricingUnit]}`
    : '';

/**
 * Suffix for a bulk quantity or MOQ, e.g. " kg". Empty for the default
 * per-unit pricing.
 */
export const pricingUnitQuantitySuffix = (
  pricingUnit: PricingUnit | null | undefined
): string =>
  pricingUnit && pricingUnit !== 'unit'
    ? ` ${PRICING_UNIT_SYMBOLS[pricingUnit]}`
    : '';
